var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCircleTag68Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34C0 15.2223 15.2223 0 34 0C52.7777 0 68 15.2223 68 34C68 52.7777 52.7777 68 34 68C15.2223 68 0 52.7777 0 34Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.997 33.286L34.697 17.986C34.085 17.374 33.235 17 32.3 17H20.4C18.53 17 17 18.53 17 20.4V32.3C17 33.235 17.374 34.085 18.003 34.714L33.303 50.014C33.915 50.626 34.765 51 35.7 51C36.635 51 37.485 50.626 38.097 49.997L49.997 38.097C50.626 37.485 51 36.635 51 35.7C51 34.765 50.609 33.898 49.997 33.286ZM35.7 47.617L20.4 32.3V20.4H32.3V20.383L47.6 35.683L35.7 47.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6496 27.2001C26.0579 27.2001 27.1996 26.0584 27.1996 24.6501C27.1996 23.2418 26.0579 22.1001 24.6496 22.1001C23.2413 22.1001 22.0996 23.2418 22.0996 24.6501C22.0996 26.0584 23.2413 27.2001 24.6496 27.2001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleTag68Px);
export default __webpack_public_path__ + "static/media/ic_circle_tag_68px.fc33ac0f5abe1a65ef3cbf568e9efcaa.svg";
export { ForwardRef as ReactComponent };